<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
    import { createEventDispatcher } from 'svelte';

    export let data;

    const dispatch = createEventDispatcher();
</script>

<input
    type="text"
    bind:value={data.value}
    on:click={evt => evt.stopPropagation()}
    on:focus={() => dispatch('action', { type: 'focus', options: { foo: 'bar' } })} />
